import R from 'ramda';
import jump from 'jump.js';

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace('/', '-')
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -

  .trim();
}

export const mapIndexed = R.addIndex(R.map);

export const slugToTitle = R.compose(R.toUpper, R.replace('-', ' '));

export function jumpToSection(id, e) {
    if (e) e.preventDefault();
    jump(id, {
      duration: distance => Math.abs(distance) / 2,
      offset: -(document.querySelector('nav').clientHeight / 3),
    });
    // if (e && getComputedStyle(document.querySelector('.toggleNav'), null).display === 'block') {
    //   this.toggleMobileNavigationMenu(e);
    // }
  }



// WEBPACK FOOTER //
// ./src/resources/utils/utilities.js